import React from 'react';

import { Chip } from '@infoods/lifebase-ui';
import {
  BILLING_PERIOD_TYPE,
  BillingPeriodType,
} from '../../constants/billingPeriodType';
import { getHumanizeBillingPeriodType } from '../../utils/getHumanizeBillingPeriodType/getHumanizeBillingPeriodType';

type BillingPeriodTypeChipProps = {
  billingPeriodType: BillingPeriodType;
};

const BillingPeriodTypeChip = ({ billingPeriodType }: BillingPeriodTypeChipProps) => {
  const label = getHumanizeBillingPeriodType(billingPeriodType);

  switch (billingPeriodType) {
    case BILLING_PERIOD_TYPE.MONTHLY:
      return <Chip label={label} color={'info'} size="small" />;
    case BILLING_PERIOD_TYPE.DAILY:
    default:
      return <Chip label={label} size="small" />;
  }
};

export { BillingPeriodTypeChip };
